import React, {useState} from 'react'
import {iProduct} from "../apis/admin/ecomerce/product.apis";
import {convertToRaw, EditorState, Modifier} from "draft-js";
import htmlToDraft from "html-to-draftjs";
// @ts-ignore
import {getSelectedBlock} from "draftjs-utils";
import {List} from "immutable";
import {v4} from "uuid";
import {iSeriesContent} from "../apis/admin/ecomerce/series.apis";
import {FaChevronDown, FaChevronUp} from "react-icons/all";

export const useIsMounted = () => {
    const ref = React.useRef(false)
    const [, setIsMounted] = React.useState(false)
    React.useEffect((): any => {
        ref.current = true
        setIsMounted(true)
        return () => (ref.current = false)
    }, [])
    return () => ref.current
}

export function validateWords(value: string, max_length: number) {
    if (value.split(' ').length <= max_length) {
        return null;
    }
    return "You have reached the maximum word limit"
}

export const getFlatKeys = (o: any, prefix = ''): string[] => {
    return Object.keys(o).flatMap(k => {
        const dot = prefix ? '.' : '';
        const new_k = isNaN(+k) ? `${dot}${k}` : `[${k}]`;
        const new_prefix = `${prefix}${new_k}`;
        return Object(o[k]) === o[k] ? getFlatKeys(o[k], new_prefix) : [new_prefix]
    });
}

export function getNestedValue(original_data: any, original_key: string, default_value: any = "-") {
    const keys = original_key.split('.');
    let data = {...original_data};
    keys.forEach(key => {
        data = data ? data[key] : default_value;
    });
    return data;
}

export function JSONTryParse(date: string) {
    try {
        return JSON.parse(date);
    } catch (e) {
        return null;
    }
}

export function validateRichTextWordCountRequired(field: any,
                                                  word_count: number,
                                                  required_message?: string,
                                                  max_error_message?: string
): string {
    const blocks = convertToRaw(field.getCurrentContent()).blocks;
    const value = blocks.map(block => (block.text.trim())).join(' ');
    if (value.length === 0) {
        return required_message || "Input in this field is required"
    }
    let words_array = value.split(" ");
    if (words_array.length > word_count) {
        return max_error_message || "Please do not exceed " + word_count + " words.";
    }
    if (value.length > word_count * 10) {
        return max_error_message || "Please do not exceed " + word_count + " words or " + word_count * 10 + " characters"
    }
    return ""
}
export function validateRichTextMinWordCountRequired(field: any,
                                                  word_count: number,
                                                  required_message?: string,
                                                  min_error_message?: string
): string {
    const blocks = convertToRaw(field.getCurrentContent()).blocks;
    const value = blocks.map(block => (block.text.trim())).join(' ');
    if (value.length === 0) {
        return required_message || "Input in this field is required"
    }
    let words_array = value.split(" ");
    if (words_array.length < word_count) {
        return min_error_message || "Please enter at least" + word_count + " words.";
    }
    return ""
}

export function validateRichTextRequired(field: any,
): boolean {
    const blocks = convertToRaw(field.getCurrentContent()).blocks;
    const value = blocks.map(block => (block.text.trim())).join(' ');
    if (value.length === 0) {
        return true
    }
    return false
}


export function getTextFromRichText(data: string) {
    try {
        let _data = JSON.parse(data);
        if (_data && _data.blocks && _data.blocks.length > 0) {
            let text = _data.blocks.map((v: any) => {
                return (v.text && v.text.trim()) || ""
            })
            return text.join(" ").trim() || ""
        }
    } catch (e) {
        return null;
    }
}

export function focusOnBook(book_col_id: string) {
    const els = document.getElementById(book_col_id);
    if (els) {
        const offset = 90;
        const bodyRect = document.body.getBoundingClientRect().top;
        const elementRect = els.getBoundingClientRect().top;
        const elementPosition = elementRect - bodyRect;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
}

export function getIndexNameCaps(index: number) {
    switch (index) {
        case 0:
            return "First";
        case 1:
            return "Second";
        case 2:
            return "Third";
        case 3:
            return "Fourth";
        case 4:
            return "Fifth";
        case 5:
            return "Sixth";
        case 6:
            return "Seventh";
        case 7:
            return "Eighth";
        case 8:
            return "Ninth";
        case 9:
            return "Tenth";
        case 10:
            return "Eleventh";
        case 11:
            return "Twelfth";
    }
    return null;
}

export function getProductLink(product?: iProduct) {
    if (!product) return "/books";
    return {pathname: "/book/" + product.seo_text + "/" + product.id, key: v4()}
}

export function handleContactNumberChange(e: any, handleChange: any) {
    let phone_no = /^[\ \d\-\+\(\)]*$/;
    if (e.target.value.match(phone_no)) {
        handleChange(e);
    }
}

export function handleOnlyNumberChange(e: any, handleChange: any) {
    let phone_no = /^[0-9]*$/;
    if (e.target.value.match(phone_no)) {
        handleChange(e);
    }
}

export function handlePastedText(text: any, html: any, editorState: any, onChange: any) {
    const selectedBlock = getSelectedBlock(editorState);
    if (selectedBlock && selectedBlock.type === "code") {

        const contentState = Modifier.replaceText(
            // @ts-ignore
            editorState.getCurrentContent(),
            editorState.getSelection(),
            text,
            editorState.getCurrentInlineStyle()
        );
        // @ts-ignore
        onChange(EditorState.push(editorState, contentState, "insert-characters"));
        return true;
    } else if (html) {
        let replace_html = html.replaceAll("font-weight:700;", "font-weight:bold;")
        replace_html = replace_html.replaceAll("font-weight:600;", "font-weight:bold;")
        replace_html = replace_html.replaceAll("font-weight:800;", "font-weight:bold;")
        replace_html = replace_html.replaceAll("font-weight:900;", "font-weight:bold;")
        replace_html = replace_html.replaceAll("font-weight:500;", "font-weight:bold;")
        replace_html = replace_html.replaceAll("<b>", "<b style='font-weight: bold'>")


        const contentBlock = htmlToDraft(replace_html,);
        let contentState = editorState.getCurrentContent();

        // @ts-ignore
        contentBlock.entityMap.forEach((value, key) => {
            contentState = contentState.mergeEntityData(key, value);
        });
        // @ts-ignore
        contentState = Modifier.replaceWithFragment(
            // @ts-ignore
            contentState,
            editorState.getSelection(),
            // @ts-ignore
            new List(contentBlock.contentBlocks)
        );
        // @ts-ignore
        onChange(EditorState.push(editorState, contentState, "insert-characters"));
        return true;
    }
    return false
}
export function HideGuideBot() {
    let ele=document.getElementById("guided_bot");
    if(ele){
        ele.style.display="none";
    }
}
export function showGuideBot() {
    let ele=document.getElementById("guided_bot");
    if(ele){
        ele.style.display="block";
    }
}

export function handleEqualAndGreaterZeroChange(e: any, handleChange: any) {
    if (!e.target.value) return handleChange(e);
    if (e.target.value === "0") {
        handleChange(e);
    }
    if (e.target.value.match(/[1-9]\d{0,5}/)) {
        if (e.target.value >= 0) {
            handleChange(e);
        }
    }

}

export function handleWithoutSpace(e: any, setFieldValue: any) {
    if (e.target.value) {
        setFieldValue(e.target.name, e.target.value.replaceAll(" ", "-"));
    }
}

export function ContentWrapper({content}: { content: string }) {
    let object: iSeriesContent[] = [];
    const [readMore, setReadMore] = useState(content.includes("read-more"));
    try {
        object = JSON.parse(content);
    } catch (e) {

    }
    if(Array.isArray(object)) {
        return <>
            <GetDynamicContent content={object}/>
        </>
    }
    return null;
}

export function GetDynamicContent({content}: { content: iSeriesContent[] }) {


        let readMoreIndex = content.findIndex(value => {
            return value.has_read_more
        });
        const [readMore, setReadMore] = useState(readMoreIndex !== -1);

        let content_till_read_more = readMoreIndex !== -1 ? [...content].splice(0, readMoreIndex + 1) : []
        if (readMoreIndex !== -1 && readMore) {
            return <>
                {
                    content_till_read_more && content_till_read_more.map(((value, index) => {
                        if (value.tag === "p" || value.tag === "ul" || value.tag === "li" || value.tag === "span") {
                            if (typeof value.children == "string") {
                                return <value.tag style={value.style} key={index}>
                                    {value.children}
                                    {
                                        value.has_read_more && <span
                                            onClick={(e) => {
                                                setReadMore(false)
                                            }}
                                            key={index} className="read-more-description"
                                            style={{color: "#1EACAE"}}>Read more <FaChevronDown/>
                                </span>
                                    }
                                </value.tag>;
                            }
                            return <value.tag key={index}>
                                <GetDynamicContentChildren content={value.children}/>
                                {
                                    value.has_read_more && <span
                                        onClick={(e) => {
                                            setReadMore(false)
                                        }}
                                        key={index} className="read-more-description"
                                        style={{color: "#1EACAE"}}>Read more <FaChevronDown/>
                                </span>
                                }
                            </value.tag>;
                        }
                        return null;

                    }))
                }

            </>
        }
        return <>
            {
                content && content.map(((value, index) => {
                    if (value.tag === "p" || value.tag === "ul" || value.tag === "li" || value.tag === "span") {
                        if (typeof value.children == "string") {
                            return <value.tag style={value.style} key={index}>
                                {value.children}
                            </value.tag>;
                        }
                        return <value.tag key={index}>
                            <GetDynamicContentChildren content={value.children}/>
                        </value.tag>;
                    }
                    return null;

                }))
            }
            {
                readMoreIndex !== -1 && <span
                    onClick={(e) => {
                        setReadMore(true)
                    }} className="read-more-description" style={{color: "#1EACAE"}}>
                       Show less <FaChevronUp/>
                    </span>
            }
        </>


}

export function GetDynamicContentChildren({content}: { content: iSeriesContent[] }) {

    return <>
        {
            content && content.map(((value, index) => {
                if (value.tag === "p" || value.tag === "ul" || value.tag === "li" || value.tag === "span") {
                    if (typeof value.children == "string") {
                        return <value.tag style={value.style} key={index}>
                            {value.children}
                        </value.tag>;
                    }
                    return <value.tag key={index}>
                        <GetDynamicContentChildren content={value.children}/>
                    </value.tag>;
                }
                return null;

            }))
        }
    </>
}
